/* eslint-disable react/require-default-props */
import React from "react";
import PropTypes from "prop-types";
import { FlexColumn, FlexRow, Header, Typography } from "design-system";

function LearningHeaderBrand({ logoSrc, title, description }) {
  return (
    <FlexRow
      align="center"
      fullWidth={false}
      gap="var(--ds-space-4)"
      className="ld-header__brand"
    >
      {logoSrc ? (
        <Typography
          component="img"
          src={logoSrc}
          alt=""
          className="ld-header__logo"
        />
      ) : null}
      {logoSrc ? (
        <span className="ld-header__logo-divider" aria-hidden />
      ) : null}
      <FlexColumn align="start" fullWidth={false} gap={0}>
        <Typography
          component="h1"
          variant="bodyMedium"
          fontWeight="semibold"
          color="ui-emphasis"
        >
          {title}
        </Typography>
        {description ? (
          <Typography component="p" variant="bodySmall" color="ui-subtle">
            {description}
          </Typography>
        ) : null}
      </FlexColumn>
    </FlexRow>
  );
}

LearningHeaderBrand.propTypes = {
  logoSrc: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default function LearningHeader({
  logoSrc,
  title,
  description,
}) {
  return (
    <Header
      className="ld-header"
      title={
        <LearningHeaderBrand
          logoSrc={logoSrc}
          title={title}
          description={description}
        />
      }
    />
  );
}

LearningHeader.propTypes = {
  logoSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};
